// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"179":"3e6183aa","241":"9658a6e4","356":"86232359","380":"5ac05d6e","460":"84362f36","488":"22b449f6","509":"fbdce31c","551":"31fb7215","728":"5f4a55f8","730":"a7533c0f","969":"356e0c3e","979":"4abd3a94"}[chunkId] + ".chunk.js";
};